import {
  faAddressCard,
  faBuilding,
  faEnvelope,
  faPhone,
  faUser,
} from "@fortawesome/fontawesome-free-solid";

import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import InputField from "../../../components/b2b/InputField";
import BookWithUs from "../../../components/landingPage/BookWithUs";
// import DemoService from "../../../components/landingPage/DemoService";
import Footer from "../../../components/landingPage/Footer";
import Header from "../../../components/landingPage/Header";
import OurServices from "../../../components/landingPage/OurServices";
import ReCAPTCHA from "react-google-recaptcha";

const initialState = {
  firstName: "",
  lastName: "",
  email: "",
  companyName: "",
  contactNumber: "",
  address: "",
};

const SignUp = () => {
  const dispatch = useDispatch();
  const [newUser, setnewUser] = useState(initialState);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setnewUser({ ...newUser, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (
      newUser.firstName === "" ||
      newUser.lastName === "" ||
      newUser.email === "" ||
      newUser.companyName === "" ||
      newUser.contactNumber === "" ||
      newUser.address === ""
    ) {
      toast.error("Please fill all the fields");
    } else {
      dispatch({ type: "REGISTER_MAIL", payload: newUser });
      setnewUser({
        firstName: "",
        lastName: "",
        email: "",
        companyName: "",
        contactNumber: "",
        address: "",
      });
    }
  };
  return (
    <div>
      <Header className="static" />

      {/* webview mode */}

      <div className="relative">
        <img
          src={require("../../../assets/images/login_landing.jpg")}
          alt=""
          className="hidden sm:block sm:h-screen md:h-1/3 lg:h-[50rem] w-screen xl:h-[42rem] object-cover"
        />

        {/* ------------------------------------ FOR SCREEN BELOW 640px --------------------------------------- */}
        <div className="bg-black sm:transparent sm:hidden w-screen h-[46rem] object-cover"></div>
        {/* ------------------------------------ FOR SCREEN BELOW 640px --------------------------------------- */}

        <div className="bg-gradient-to-r from-[#121518] to-[#322d2d] w-full h-[42rem] sm:h-full opacity-80 absolute top-0"></div>

        {/* form */}
        <div className="h-full opacity-100 w-full pt-3 absolute px-5 transform -translate-y-[660px] sm:-translate-y-[560px] md:-translate-y-[515px] lg:-translate-y-[645px] xl:-translate-y-[595px]">
          <div className="flex space-x-0 mb-2.5 px-10"></div>
          <div className="text-3xl font-semibold text-center text-white pb-10">
            Signup to your account
          </div>

          <form
            action=""
            className="flex-wrap mx-auto space-y-2 w-[20rem] sm:w-[25rem] -mt-5 sm:mt-0 md:-mt-3"
          >
            <div className="mx-auto sm:flex justify-center sm:space-x-2 space-y-2 sm:space-y-0">
              <InputField
                isFontawesome={true}
                fontawesomeIcon={faUser}
                placeholder="First name"
                id="firstName"
                name="firstName"
                type="text"
                value={newUser.firstName}
                onChange={handleChange}
              />
              <InputField
                isFontawesome={true}
                fontawesomeIcon={faUser}
                placeholder="Last name"
                id="last-name"
                name="lastName"
                type="text"
                value={newUser.lastName}
                onChange={handleChange}
              />
            </div>
            <div className="space-y-2 mx-auto">
              <InputField
                isFontawesome={true}
                fontawesomeIcon={faEnvelope}
                placeholder="Email address"
                id="email-address"
                name="email"
                type="email"
                value={newUser.email}
                onChange={handleChange}
              />
              <InputField
                isFontawesome={true}
                fontawesomeIcon={faEnvelope}
                placeholder="Confirm email address"
                id="email-address"
                name="email"
                type="email"
                value={newUser.email}
                onChange={handleChange}
              />

              <div className="sm:flex sm:space-x-2 space-y-2 sm:space-y-0">
                <InputField
                  isFontawesome={true}
                  fontawesomeIcon={faBuilding}
                  placeholder="Company Name"
                  id="comname"
                  name="companyName"
                  type="text"
                  value={newUser.companyName}
                  onChange={handleChange}
                />
                <InputField
                  isFontawesome={true}
                  fontawesomeIcon={faPhone}
                  placeholder="Contact Number"
                  id="contact"
                  name="contactNumber"
                  type="number"
                  value={newUser.contactNumber}
                  onChange={handleChange}
                />
              </div>
              <div className="">
                <InputField
                  isFontawesome={true}
                  fontawesomeIcon={faAddressCard}
                  placeholder="Address"
                  id="address"
                  name="address"
                  type="textarea"
                  value={newUser.address}
                  onChange={handleChange}
                />
              </div>

              {/* <ReCAPTCHA sitekey={process.env.REACT_APP_RECAPTCHA_KEY} /> */}

              {/* FOR DESKTOP VIEW */}
              <div className="hidden sm:flex justify-between mx-auto">
                <div className="flex sm:flex-col space-x-3 sm:space-x-0 text-sm text-white">
                  <div className="text-white text-sm md:text-base">
                    Already have an account?
                  </div>
                  <div className="underline cursor-pointer underline-offset-4 text-secondary hover:text-white">
                    <Link to="/login"> Login </Link>
                  </div>
                </div>
                <button
                  onClick={handleSubmit}
                  className="hover:bg-gray-700 cursor-pointer w-full sm:w-52 font-normal uppercase bg-secondary text-white py-1.5 rounded-sm mt-3 sm:mt-0"
                >
                  Signup
                </button>
              </div>

              {/* FOR MOBILE VIEW */}
              <div className="sm:hidden justify-between mx-auto">
                <button
                  onClick={handleSubmit}
                  className="hover:bg-gray-700 cursor-pointer w-full sm:w-52 font-normal uppercase bg-secondary text-white py-1.5 rounded-sm mb-2 sm:mt-0"
                >
                  Signup
                </button>
                <div className="flex sm:flex-col space-x-3 sm:space-x-0 text-sm text-white">
                  <div className="text-white text-sm md:text-base">
                    Already have an account?
                  </div>
                  <div className="underline cursor-pointer underline-offset-4 text-secondary hover:text-white">
                    <Link to="/login"> Login </Link>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      {/* <BookWithUs /> */}
      {/* Our Services  */}
      {/* <OurServices /> */}
      {/* car animation */}
      {/* <div className="hidden sm:hidden md:hidden lg:inline ">
        <DemoService />
      </div> */}
      {/* footer */}
      <Footer />
    </div>
  );
};

export default React.memo(SignUp);
